export const ATTRIBUTION_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'gad_source',
    'gad_campaignid',
    'gclid',
] as const;

export type AttributionParam = typeof ATTRIBUTION_PARAMS[number];

export type AttributionData = Partial<Record<AttributionParam, string>> & {
    capturedAt?: string,
};

export const ATTRIBUTION_COOKIE = 'spreo-attribution';

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

export const parseAttributionFromUrl = (search?: string): AttributionData => {
    const params = new URLSearchParams(search ?? (typeof window !== 'undefined' ? window.location.search : ''));
    const attribution: AttributionData = {};

    for (const key of ATTRIBUTION_PARAMS) {
        const value = params.get(key);
        if (value) {
            attribution[key] = value;
        }
    }

    return attribution;
};

export const persistAttributionCookie = () => {
    if (typeof document === 'undefined') return;

    const attribution = parseAttributionFromUrl();
    if (Object.keys(attribution).length === 0) return;

    const payload = JSON.stringify({
        ...attribution,
        capturedAt: new Date().toISOString(),
    });

    document.cookie = [
        `${ATTRIBUTION_COOKIE}=${encodeURIComponent(payload)}`,
        'path=/',
        `max-age=${COOKIE_MAX_AGE_SECONDS}`,
        'SameSite=Lax',
    ].join('; ');
};
